module.exports = __webpack_public_path__ + "static/media/lock.8d15cc48.svg";